import { useId } from 'react';

const QuantityCircleAddIcon = ({
  size = 18,
  color = '#767676',
  className = '',
  ...props
}) => {
  const clipId = useId().replace(/:/g, '');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M9 5.33138V8.99805M9 8.99805V12.6647M9 8.99805H12.6667M9 8.99805H5.33333M17 8.99805C17 13.4163 13.4183 16.998 9 16.998C4.58172 16.998 1 13.4163 1 8.99805C1 4.57977 4.58172 0.998047 9 0.998047C13.4183 0.998047 17 4.57977 17 8.99805Z"
          stroke={color}
          strokeWidth="1.14662"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuantityCircleAddIcon;
